import { nanoid } from 'nanoid'
import React from 'react'
import modalStore from 'shared/ui/Modal/store/modalStore.ts'
import { type IActionTagProps } from 'widgets/TemplateActions/addTag'
import { AddTagContent } from 'widgets/TemplateActions/ui/AddTagContent/AddTagContent.tsx'

export const addTag = (props: IActionTagProps) => {
  const id = nanoid()
  modalStore.addModal({
    id,
    title: 'Add tag',
    pureContent: true,
    ModalContent: () => (
      <AddTagContent onClose={() => modalStore.closeModal(id)} canCreate={true} {...props} />
    ),
  })
}
